/**
 * Utilitários para sanitização de entrada e prevenção de XSS
 */

/**
 * Sanitiza texto para prevenir XSS
 * @param {string} input - Texto a ser sanitizado
 * @returns {string} - Texto sanitizado
 */
export const sanitizeText = (input) => {
  if (!input) return '';
  
  // Converte caracteres especiais em entidades HTML
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  
  return input.replace(/[&<>"']/g, (m) => map[m]);
};

/**
 * Sanitiza URL para prevenir XSS via javascript: URLs
 * @param {string} url - URL a ser sanitizada
 * @returns {string|null} - URL sanitizada ou null se for maliciosa
 */
export const sanitizeUrl = (url) => {
  if (!url) return null;
  
  // Verifica se a URL começa com protocolos seguros
  const sanitized = url.trim().toLowerCase();
  if (sanitized.startsWith('javascript:') || 
      sanitized.startsWith('data:') || 
      sanitized.startsWith('vbscript:')) {
    return null;
  }
  
  return url;
};

/**
 * Sanitiza valores para uso seguro em atributos HTML
 * @param {string} value - Valor a ser sanitizado
 * @returns {string} - Valor sanitizado
 */
export const sanitizeAttribute = (value) => {
  if (!value) return '';
  
  // Remove caracteres potencialmente perigosos em atributos
  return value.replace(/[^\w\s-]/gi, '');
};

/**
 * Sanitiza entrada de HTML para uso em innerHTML (use com cuidado)
 * @param {string} html - HTML a ser sanitizado
 * @returns {string} - HTML sanitizado
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  
  // Cria um elemento temporário
  const tempElement = document.createElement('div');
  tempElement.textContent = html; // Isso converte automaticamente para texto
  
  return tempElement.innerHTML;
};

/**
 * Verifica se uma string contém código JavaScript potencialmente malicioso
 * @param {string} input - Texto a ser verificado
 * @returns {boolean} - True se contiver código suspeito
 */
export const containsSuspiciousCode = (input) => {
  if (!input) return false;
  
  const suspicious = [
    'eval(',
    'setTimeout(',
    'setInterval(',
    'Function(',
    'document.cookie',
    'document.write(',
    'document.location',
    'window.location',
    'localStorage',
    'sessionStorage',
    'indexedDB',
    'onerror=',
    'onload=',
    'onclick=',
    '<script',
    '<iframe'
  ];
  
  const lowerInput = input.toLowerCase();
  return suspicious.some(pattern => lowerInput.includes(pattern));
}; 